export default "__VITE_ASSET__DZ14wveE__"